export const getUserEmail = (localStorage: Storage): string => {
  const item = localStorage.getItem("SGWTConnectStorage.AUTH");
  if (item === null) {
    return "";
  }

  const id_token: string = JSON.parse(item).id_token;
  const binaryUserEmail = id_token.split(".")[1];

  if (binaryUserEmail === null) {
    return "";
  }

  return JSON.parse(atob(binaryUserEmail)).sub;
};
